import React from 'react';
import { skillColor } from './constants';

const FilterBox = ({
  activeCategory,
  setActiveCategory,
  uniqueCategories,
  handleCategoryClick,
}) => {
  return (
    <div style={styles.container}>
      <div style={styles.button}>
        <label
          style={{
            ...styles.filterButton,
            ...(activeCategory === 'all' && styles.activeFilterButton),
          }}
        >
          <input
            type='radio'
            name='category'
            value='all'
            checked={activeCategory === 'all'}
            onChange={() => handleCategoryClick('all')}
          />
          All
        </label>
      </div>
      {/* Render the filter radio buttons for unique categories */}
      {uniqueCategories.map((category, index) => (
        <div style={styles.button} key={category}>
          <label
            style={{
              ...styles.filterButton,
              ...(activeCategory === category && styles.activeFilterButton),
              // ...{ backgroundColor: 'black' },
            }}
          >
            <input
              type='radio'
              name='category'
              value={category}
              checked={activeCategory === category}
              onChange={() => handleCategoryClick(category)}
              key={`${category}-${index}`} // Assign a unique key based on category and index
            />
            {category}
          </label>
        </div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center', // not alignItems :center
  },
  button: {
    marginBottom: '5px',
    display: 'flex',
    // flexDirection: 'column',
  },
  filterButton: {
    marginRight: '8px',
    padding: '4px 8px',
    borderRadius: '4px',
    // backgroundColor: '#eee',
    cursor: 'pointer',
  },
  activeFilterButton: {
    // backgroundColor: skillColor,
    backgroundColor: 'white',
    color: skillColor,
    fontWeight: 'bold',
    fontSize: '16px',
  },
};

export default FilterBox;
